import styled from 'styled-components';
import bg_04 from '../../assets/images/bg_04.png';

export const Wrapper = styled.div`
  height:100vh;overflow:auto;padding-top:4.6rem;
  padding-bottom:0;padding-bottom:env(safe-area-inset-bottom);background:#F7F7F7;
`;

export const Container = styled.div`
  .topFixed{
    width:100%;height:4.6rem;position:fixed;top:0;z-index:11;background: #F3F4F5;box-sizing:border-box;max-width: 475px;margin: 0 auto;
  }
 .bg{
    width:100%;height:3.36rem;background:url(${bg_04}) no-repeat;background-size:100%;padding-top:.4rem;
    span{
      height: .7rem;font-size: .6rem;font-weight: 400;color: #FFFFFF;line-height: .7rem;text-align:center;display:block;
    }
    b{
      height: .34rem;font-size: .24rem;font-weight: 400;color: #FFFFFF;line-height: .34rem;text-align:center;display:block;
    }
  }
  .navs{
    width: 92%;height: 1.77rem;background: #FFFFFF;box-shadow: 0px .02rem 1.4rem .06rem rgba(72, 119, 213, 0.11);
    border-radius: .1rem;margin: -1.52rem auto 0;display:flex;align-items:center;justify-content:center;
    .nums{
      height:.95rem;display:flex;align-items:center;justify-content:center;flex:1;
      .item{
        flex:1;
        span{
          height: .53rem;font-size: .5rem;font-weight: 700;color: #3B3D41;line-height: .53rem;text-align:center;display:block;
        }
        span.red{
          color:#ED933C;
        }
        b{
          height: .33rem;font-size: .24rem;font-weight: 400;color: #9DA1A6;line-height: .33rem;text-align:center;display:block;margin-top:.08rem;
        }
      }
    }
    .num1{
      border-right: 1px solid #DDDDDD;
    }
  }
  .title{
    height: .4rem;font-size: .28rem;font-weight: 400;color: #3B3D41;line-height: .4rem;margin-top:.4rem;padding-left:.34rem;
  }
  .lists{
    padding:0 .3rem .3rem;
    .list{
      background: #FFFFFF;border-radius: .1rem;padding:.3rem .2rem;
      .item{
        height:.7rem;display:flex;align-items:center;justify-content:center;margin-top:.4rem;
        .left{   
          margin-right:.45rem;
          p{
            height: .4rem;font-size: .28rem;font-weight: 600;color: #3B3D41;line-height: .4rem;
          }
          span{
            height: .3rem;font-size: .22rem;font-weight: 400;color: #9DA1A6;line-height: .3rem;display:block;
          }
        }
        .center{
          p{
            height: .34rem;font-size: .24rem;font-weight: 400;color: #3B3D41;line-height: .34rem;margin-top:.04rem;
          }
          span{
            height: .3rem;font-size: .22rem;font-weight: 400;color: #9DA1A6;line-height: .3rem;margin-top:.02rem;display:block;
          }
        }
        .right{
          flex:1;display:flex;align-items:center;justify-content:flex-end;
          p{
            font-size: .32rem;font-weight: 400;color: #3B3D41;margin:.04rem 0 0 0;
          }
          b{
            font-size: .25rem;font-weight: 400;color: #3B3D41;margin:.08rem 0 0 0;
          }
          span{
            font-size: .32rem;font-weight: 700;color: #3B3D41;
          }      
        }
        .right.red{
          p,b,span{
            color: #C57272;
          }
        }    
      }
      .item:nth-child(1){
        margin-top:0;
      }
    }
    .tips{
      font-size:.26rem;text-align:center;margin-top: .3rem;color:#999999;
    }
  }
`; 